/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationTechnique from './radiation-technique';
import RadiationTechniqueDetail from './radiation-technique-detail';
import RadiationTechniqueUpdate from './radiation-technique-update';
import RadiationTechniqueDeleteDialog from './radiation-technique-delete-dialog';

const RadiationTechniqueRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationTechnique />} />
    <Route path="new" element={<RadiationTechniqueUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationTechniqueDetail />} />
      <Route path="edit" element={<RadiationTechniqueUpdate />} />
      <Route path="delete" element={<RadiationTechniqueDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationTechniqueRoutes;
